import basicdata from '@manage/api/api.basicdata'
export default [
  {
    type: 'input',
    placeholder: '标题',
    filed: 'title',
    default: ''
  },
  {
    type: 'select',
    placeholder: '类型',
    filed: 'type',
    default: '',
    query: basicdata.knowledge_type_select
  },
  {
    type: 'input',
    placeholder: '添加人',
    filed: 'userName',
    default: ''
  },
  {
    type: 'datepicker',
    filed: 'daterange',
    params: {
      start: 'startTime',
      end: 'endTime'
    },
    default: ''
  }
]
